<template>
  <div class="grid-container">
    <div class="grid-row">
      <InmuebleFacturasGrid :inmueble-id="props.inmuebleId" />
    </div>
    <div class="grid-row">
      <div class="lecturas">

        <h5 class="text-success">{{ $t("inmueble.ui.lecturas") }}</h5>

        <DxTabPanel height="95%" tabs-position="top" icon-position="left" :defer-rendering="false">
          <DxItem :key="1" :title="$t('inmueble.ui.lecturaContador') + ' ' + $t('tipoFacturaInmueble.values.LUZ')"
            class="tab-item" :disabled="false" icon="fa-regular fa-lightbulb">
            <InmuebleLecturasGrid :inmueble-id="props.inmuebleId" :tipo-suministro="TipoSuministroInmuebleEnum.Luz" />
          </DxItem>
          <DxItem :key="2" :title="$t('inmueble.ui.lecturaContador') + ' ' + $t('tipoFacturaInmueble.values.GAS')"
            class="tab-item" :disabled="false" icon="fa-regular fa-fire">
            <InmuebleLecturasGrid :inmueble-id="props.inmuebleId" :tipo-suministro="TipoSuministroInmuebleEnum.Gas" />
          </DxItem>
          <DxItem :key="3" :title="$t('inmueble.ui.lecturaContador') + ' ' + $t('tipoFacturaInmueble.values.AGUA')"
            class="tab-item" :disabled="false" icon="fa-regular fa-droplet">
            <InmuebleLecturasGrid :inmueble-id="props.inmuebleId" :tipo-suministro="TipoSuministroInmuebleEnum.Agua" />
          </DxItem>
        </DxTabPanel>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import InmuebleFacturasGrid from '@/components/inmuebles/InmuebleFacturasGrid.vue';
import InmuebleLecturasGrid from '@/components/inmuebles/InmuebleLecturasGrid.vue';
import { TipoSuministroInmuebleEnum } from '@/.shared/.api';
import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel';

const props = defineProps({
  inmuebleId: {
    type: String,
    required: true
  }
});
</script>

<style scoped>
</style>
